export function formatRam(mb) {
  if (mb == null || mb === '') return '—'
  const n = Number(mb)
  if (Number.isNaN(n)) return '—'
  if (n >= 1024) return `${(n / 1024).toFixed(1)} GB`
  return `${n} MB`
}

export function formatCpuSpeed(mhz) {
  if (mhz == null) return null
  return `${(mhz / 1000).toFixed(2)} GHz`
}

export function formatOs(agent) {
  const name = agent.os_name || ''
  const ver = agent.os_version
  if (name && ver) return `${name} (${ver})`
  return name || ver || '—'
}

export function formatLastSeen(iso) {
  if (!iso) return '—'
  return new Date(iso).toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

/** Date only (en-GB). */
export function formatDateOnly(value) {
  if (value == null || value === '') return '—'
  const text = String(value).trim()
  if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
    const [y, m, d] = text.split('-').map(Number)
    return new Date(y, m - 1, d).toLocaleDateString('en-GB')
  }
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) {
    return text.replace(/[,\s]+\d{1,2}:\d{2}(?::\d{2})?.*$/, '').trim() || text
  }
  return parsed.toLocaleDateString('en-GB')
}

/** Date/time without seconds (en-GB). */
export function formatDateTime(value) {
  if (value == null || value === '') return '—'
  const text = String(value).trim()
  if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
    const [y, m, d] = text.split('-').map(Number)
    return new Date(y, m - 1, d).toLocaleDateString('en-GB')
  }
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) {
    return text.replace(/(\d{1,2}:\d{2}):\d{2}(?=\D|,|$)/g, '$1')
  }
  return parsed.toLocaleString('en-GB', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}
